
import { motion } from "framer-motion";

interface ShapeProps {
  size: number;
  top: string;
  left: string;
  rotation: number;
  color: string;
  delay: number;
  duration: number;
}

const Triangle = ({ size, top, left, rotation, color, delay, duration }: ShapeProps) => {
  return (
    <motion.div
      className="absolute opacity-[0.07]"
      style={{
        top,
        left,
        width: 0,
        height: 0,
        borderLeft: `${size/2}px solid transparent`,
        borderRight: `${size/2}px solid transparent`,
        borderBottom: `${size}px solid ${color}`,
      }}
      initial={{ opacity: 0, rotate: rotation }}
      animate={{ 
        opacity: [0.03, 0.07, 0.03],
        rotate: [rotation, rotation + 15, rotation],
        y: [0, -15, 0]
      }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        ease: "easeInOut"
      }}
    />
  );
};

export const GeometricShapes = () => {
  const shapes = [
    { id: 1, size: 300, top: '5%', left: '-5%', rotation: 45, color: '#0000bd', delay: 0, duration: 20 },
    { id: 2, size: 200, top: '70%', left: '85%', rotation: 180, color: '#0000bd', delay: 2, duration: 18 },
    { id: 3, size: 250, top: '40%', left: '90%', rotation: 135, color: '#0000bd', delay: 1, duration: 22 },
    { id: 4, size: 180, top: '80%', left: '10%', rotation: 90, color: '#0000bd', delay: 0.5, duration: 25 },
    { id: 5, size: 400, top: '10%', left: '60%', rotation: 210, color: '#0000bd', delay: 1.5, duration: 28 },
  ];

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-20">
      {shapes.map((shape) => (
        <Triangle
          key={shape.id}
          size={shape.size}
          top={shape.top}
          left={shape.left}
          rotation={shape.rotation}
          color={shape.color}
          delay={shape.delay}
          duration={shape.duration}
        />
      ))}
    </div>
  );
};
